import CityField from "./ContactInputFields/CityField";
import EmailField from "./ContactInputFields/EmailField";
import FirstNameField from "./ContactInputFields/FirstNameField";
import LastNameField from "./ContactInputFields/LastNameField";
import PhoneNumberField from "./ContactInputFields/PhoneNumberField";
import PropTypes from "prop-types";
import React from "react";
import StateField from "../../../../shared/components/StateField";
import StreetAddressField from "./ContactInputFields/StreetAddressField";
import UnitNumberField from "./ContactInputFields/UnitNumberField";
import ZipCodeField from "./ContactInputFields/ZipCodeField";

const ContactFormFields = ({handleChange, updateValidatedEmail, parentState}) => {
  const {firstName, lastName, streetAddress, unitNumber, city, state, zipCode, phoneNumber} = parentState;
  return (
    <div className="fieldset">
      <fieldset>
        <FirstNameField
          changeHandler={handleChange}
          firstName={firstName}
        />
        <LastNameField
          changeHandler={handleChange}
          lastName={lastName}
        />

        <StreetAddressField
          changeHandler={handleChange}
          streetAddress={streetAddress}
        />
        <UnitNumberField
          changeHandler={handleChange}
          unitNumber={unitNumber}
        />

        <CityField
          changeHandler={handleChange}
          city={city}
        />

        <StateField
          changeHandler={handleChange}
          state={state}
        />
        <ZipCodeField
          changeHandler={handleChange}
          zipCode={zipCode}
        />

        <EmailField
          updateValidatedEmail={updateValidatedEmail}
        />

        <PhoneNumberField
          changeHandler={handleChange}
          phoneNumber={phoneNumber}
        />

        <div className="hidden">
          <input
            data-recurly="country"
            disabled
            value="US"
          />
        </div>
      </fieldset>
    </div>
  );
};

export default ContactFormFields;

ContactFormFields.propTypes = {
  "handleChange": PropTypes.func.isRequired,
  "parentState": PropTypes.object.isRequired,
  "updateValidatedEmail": PropTypes.func.isRequired
};
